import { FC, useState } from 'react';
import { TimeFilterContextState, TimeParams } from 'modules/iterableGoals/types';
import { initalTimeFilterContextState, TimeFilterContext } from './TimeFilterContext';
import { useTabContext } from './TabContext';

export const TimeFilterContextProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { loadAllSections } = useTabContext();
  const [timeParams, setTimeParams] = useState<TimeParams>(initalTimeFilterContextState.timeParams);

  const context: TimeFilterContextState = {
    timeParams,
    updateTimeParams: (updatedTimeParams) => {
      loadAllSections();
      setTimeParams(updatedTimeParams);
    },
  };

  return <TimeFilterContext.Provider value={context}>{children}</TimeFilterContext.Provider>;
};
